import useUserStore from '@/store/useUserStore';
import { logout } from '@/store';
import { checkPageNeedLogin } from '@/router';
import {
  distributionSiteUrl,
  newDistributionInviteUrl,
  historyDistributionInviteUrl,
  historyDistributionSiteUrl,
} from '@/router/config';

export default {
  async onLaunch(options = {}) {
    const userStore = useUserStore();
    const errorHandler = () => {
      // 使用redirectTo跳转 防止后退白屏
      logout('reLaunch').then(() => this.closeSplashscreen());
    };
    // #ifdef H5
    const isHistoryDistributionInviteUrl =
      this.compatibleHistoryDistributionInviteUrl(options);
    if (isHistoryDistributionInviteUrl) {
      return;
    }
    // #endif
    // 每次打开应用 重新登录
    // #ifndef H5
    let isToDistributionSite = false;
    // #ifdef MP-WEIXIN
    const scene = options.scene;
    const path = options.path || '';
    const queryObj = options.query || {};
    const availableScene = [1065, 1286];
    // 小程序扫二维码跳转分销小站不需要重登陆，场景值为URL Scheme打开小程序场景值
    isToDistributionSite =
      availableScene.includes(scene) && path === distributionSiteUrl;
    if (isToDistributionSite) {
      const query = queryObj.query || '';
      if (query) {
        return uni.redirectTo({
          url: `/${distributionSiteUrl}?query=${query}`,
        });
      }
    }
    // #endif
    const needLogin = checkPageNeedLogin();
    const isReLoginSuccess = await userStore.reLogin();
    if (needLogin && !isReLoginSuccess) {
      return errorHandler();
    }
    // #endif
    const pages = getCurrentPages();
    const currentPage = pages[pages.length - 1];
    const pagePath = currentPage?.$page?.fullPath;
    const routerUrl = '/pages/warehouse/index';
    if (routerUrl !== pagePath) {
      uni
        .switchTab({
          url: routerUrl,
        })
        .finally(() => {
          this.closeSplashscreen();
        });
    } else {
      this.closeSplashscreen();
    }
  },
  methods: {
    closeSplashscreen() {
      // #ifdef APP-PLUS
      plus.navigator.closeSplashscreen();
      // #endif
    },
    /**
     * 兼容旧版分销邀请链接
     * https://hosts/#/pages/distribution/site/index?code=xxx
     * https://hosts/#/pages/distribution/bind/index?code=xxx
     */
    compatibleHistoryDistributionInviteUrl(options) {
      const path = options.path || '';
      const query = options.query || {};
      const code = query.code || '';
      let mode = '';
      if (path === historyDistributionInviteUrl) {
        mode = 'invite';
      } else if (path === historyDistributionSiteUrl) {
        mode = 'station';
      }
      if (mode && code) {
        const queryArr = Object.keys(query).map(
          (item) => `${item}=${query[item]}`
        );
        const queryStr = queryArr.join('&');
        uni.redirectTo({
          url: `/${newDistributionInviteUrl}?${queryStr}&mode=${mode}`,
        });
        return true;
      }
      return false;
    },
  },
};
